/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { UserProfileDTO } from '../model/models';
import { UserProfileUpdateForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface UpdateProfiloOperatoreRequestParams {
    userProfileUpdateForm: UserProfileUpdateForm;
}


export interface ProfiloOperatoreBackofficeServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lettura del proprio profilo identita\&#39;.
     * Audience backoffice. Se il profilo non esiste ancora (operatore mai passato dalla pagina), ritorna HTTP 200 con DTO empty (tutti i campi null) — il PUT successivo lo crea (decisione D8 revisionato).
     * @endpoint get /api/v1/gestione/profilo
*/
    getProfiloOperatore(extraHttpRequestParams?: any): Observable<UserProfileDTO>;

    /**
     * Aggiornamento (upsert) del proprio profilo identita\&#39;.
     * Audience backoffice. Auto-create se il profilo non esiste (D8 revisionato). CF editabile per operatori (D7 revisionato): nessuna restrizione system-only.
     * @endpoint put /api/v1/gestione/profilo
* @param requestParameters
     */
    updateProfiloOperatore(requestParameters: UpdateProfiloOperatoreRequestParams, extraHttpRequestParams?: any): Observable<UserProfileDTO>;

}
